import { useEffect, useState } from "react";
import { SignUpCheckBoxStyled } from "../../SignUp/Renewal/css/ReSignUpStyled";
import { NewCalculateButton } from "../css/CorporateBusinessStyled";
import { TextTitleStyled } from "../css/FlexDiv";
import { ScrollableDiv } from "../css/ScrillableDiv";
import { postPopupTrue } from "../../MyPage/Renewal/repo/PopupAPI";
import { useDispatch, useSelector } from "react-redux";
import {
  allPopupOpenState,
  popupOpenState,
} from "../../../common/redux/action/PopupAction";

export const NewCalculate = () => {
  const [isCheck, setCheck] = useState(false);
  const popupData = useSelector((state) => state.popUpState?.popupData?.[0]);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    setCheck(e.target.checked);
  };

  useEffect(() => {
    console.log("채크박스", isCheck);
  }, [isCheck]);

  const handleCheckTrue = async () => {
    try {
      const resp = await postPopupTrue(popupData?.id);

      if (resp.data === true) {
        dispatch(popupOpenState(false));
        dispatch(allPopupOpenState(false));
      }
    } catch (error) {
      console.log("동의 에러 ", error);
    }
  };

  return (
    <>
      <div
        style={{
          color: `#3632ff`,
          fontWeight: `700`,
        }}
      >
        현재 변경된 내용에 동의하지 않아 정산 불가한 상황입니다. 정산을 원하시면
        동의 부탁드리겠습니다.
      </div>
      <SignUpCheckBoxStyled>
        <input
          type="checkBox"
          className="input-checkBox"
          value={isCheck}
          onChange={handleChange}
        />{" "}
        <div
          style={{
            width: `10px`,
          }}
        ></div>
        <TextTitleStyled>변경된 이용약관 내용 동의</TextTitleStyled>
      </SignUpCheckBoxStyled>
      <ScrollableDiv>
        <div>후원한잔 이용약관 제 7조 14항 추가</div>
        <br />
        <div>
          후원금에 대한 정산 대상자의 경우 정산 금액에 대한 정산서가 발급되며,
          정산 대상자는 정산서 확인 조치를 취해야만 정산금액을 지급합니다.
        </div>
        <div
          style={{
            marginTop: `10px`,
            marginBottom: `10px`,
          }}
        >
          정산서 확인 방법은 다음과 같습니다.
        </div>
        <div
          style={{
            marginLeft: `20px`,
          }}
        >
          {`1) 서비스 페이지(후원한잔 페이지)내 "정산확인"탭에서 정산서 확인 후 확인상태의 <확인하기> 버튼 클릭`}
        </div>
      </ScrollableDiv>
      <div
        style={{
          display: `flex`,
          justifyContent: `end`,
          marginBottom: `20px`,
        }}
      >
        <NewCalculateButton
          disabled={!isCheck}
          onClick={() => handleCheckTrue()}
        >
          확인
        </NewCalculateButton>
      </div>
    </>
  );
};
